import { BrandEntities } from './BrandEntities'
import { Menu } from './Menu'
import { UpButton } from './UpButton'
import { General } from './General'

export const Component = { BrandEntities, Menu, UpButton, General }
